import { bus, axios, apiURL } from '../main'
import moment from "moment";

export default {
    state: { // state des Moduls wird direkt auf die variable state.modulX gemappt
        analysen: [
            /*
            { ID: 1, MpdHemmstoff: 1, BtrfrmCode: "PB", PID: 1, MpdID: 0, MpdPeriode: 201607, AGIS: 1, VerGehalt: 1, MpdKasein: "", MpdFettsaeuren: "", AnatypName: "Monatswert", MpdHarnstoff: "", Print: "", MpdMilchsperre: 0, MpdDatum: "01.07.2016", MpdRefcodeLabor: 123456, MpdEiweiss: "", Tierart: "Kuh", TierartID: 1, MpdStornierung: "", PerdtaName1: "pls wait..", AnatypID: 4, PerdtaName2: "", MpdKeime: 123, MpbTotal: 0.0, Lieferant: 1, MpdZellen: 12345, MpdFett: "", PlzPLZ: 0, PlzOrt: "", MpdGefrierpunkt: "" },
            { ID: 1, MpdHemmstoff: 1, BtrfrmCode: "PB", PID: 1, MpdID: 0, MpdPeriode: 201607, AGIS: 1, VerGehalt: 1, MpdKasein: "", MpdFettsaeuren: "", AnatypName: "Monatswert", MpdHarnstoff: "", Print: "", MpdMilchsperre: 0, MpdDatum: "01.07.2016", MpdRefcodeLabor: 123456, MpdEiweiss: "", Tierart: "Kuh", TierartID: 1, MpdStornierung: "", PerdtaName1: "pls wait..", AnatypID: 4, PerdtaName2: "", MpdKeime: 123, MpbTotal: 0.0, Lieferant: 1, MpdZellen: 12345, MpdFett: "", PlzPLZ: 0, PlzOrt: "", MpdGefrierpunkt: "" }
            */
        ],
        analysenLoadedYears: [], //Geladene Jahr [2018,2017]
        analysenFiltered: [],
        analysenExpired: 0,
        latestRefID: 0,
        anatyp: [
            { AnatypID: 1, AnatypName_de: 'Qualität', AnatypName_fr: 'Qualité', AnatypName_it: 'Qualità' },
            { AnatypID: 2, AnatypName_de: 'Gehalt', AnatypName_fr: 'Teneur', AnatypName_it: 'Contenuto' },
            /*{ AnatypID: 3,  AnatypName_de: 'Sammelstelle',AnatypName_fr:'Centre de collectage',AnatypName_it:'Centro di raccolta'},*/
            { AnatypID: 4, AnatypName_de: 'Monatswert', AnatypName_fr: 'Moyenne', AnatypName_it: 'Media' },
        ],
        anatypSelected: null,
        sortTable: { sortBy: 'MPDDATUM', sortDesc: true },
        labor: [{ labSysDomID: 38, labName: 'Suisselab AG Zollikofen' }, { labSysDomID: 1, labName: 'TSM Treuhand GMBH' }],
        load: {
            timeout: 40 * 1000,        // axios timeout
            intervall: 3600 * 1000,    // server reload analyses
            tic: 60 * 1000,            // windows.setintervall tic to proof the intervall
            resetedOn: 0              // time in Milisec seit 1970 wenn die differenz zu jetzt grösser als 1h = 3600'000 ist, aktualisieren.
        }
    },
    actions: { // call from outside as action: this.$store.dispatch('LOAD_abcd')

        // löscht loadedYears und setzt den status der analysen zurück
        resetAnalysen: async function ({ state, dispatch }, filter) {
            state.load.resetedOn = new Date().getTime(); //time in Milisec seit 1970 wenn die differenz zu jetzt grösser als 1h = 3600'000 ist, aktualisieren.
            state.analysenLoadedYears = []
            state.analysen = []
            dispatch('loadAnalysen', filter)
        },

        // load analysen lädt nur jahre wenn diese noch nicht unter store.loadedYears eingebucht sind
        loadAnalysen: async function ({ state, commit, dispatch }, filter) {
            let jahrvon = moment(filter.von).year()
            let jahrbis = moment(filter.bis).year()
            for (var jahrX = jahrbis; jahrX > jahrvon - 1; jahrX--) {
                if (state.analysenLoadedYears.includes(jahrX)) {
                    //year already loaded .. do nothing
                }
                else {
                    try {
                        state.analysenLoadedYears.push(jahrX)
                        var analysen = await axios.get(apiURL + 'analysen.cfc?method=getData', { params: { Jahr: jahrX }, timeout: state.load.timeout })  //immer alle
                        commit('setAnalysen', analysen.data)
                        dispatch('buildFilteredAnalyen', filter)
                        state.analysenLoadedYears.push(jahrX)
                    }
                    catch (e) {
                        //etwas ist schief gelaufen jahr wieder entfernen
                        state.analysenLoadedYears.pop()
                        bus.$emit('error', 'Analysen konnten nicht geladen werden ..' + JSON.stringify(e.message))
                    }
                }
            }

        },
        setProbetypSelected: function ({ commit }, value) {
            commit('setProbetypSelected', value)
        },
        buildFilteredAnalyen: function ({ commit }, filter) {
            //console.log('FILTER')
            //console.log(filter)
            commit('buildFilteredAnalyen', filter)
        },
        setAnatypSelected({ commit }, value) {
            commit('setAnatypSelected', value)
        },
    },
    mutations: { //call with this.$store.commit('setExampleFn',{'a':'b'})
        setAnalysen: async function (state, analysen) {
            // Grenzwerte um die Tabelle einzufärben  _cellVariants: { age: 'danger', isActive: 'danger'}
            // Grenzwerte für Kuh, bei AST nur Hemmstoff
            analysen.map(function (analyseX) {
                let _cellVariants = {}
                if (typeof analyseX.MPDHEMMSTOFF == 'number' && analyseX.MPDHEMMSTOFF == 1) { _cellVariants.MPDHEMMSTOFF = 'danger' }
                if (typeof analyseX.MPDZELLEN == 'number' && analyseX.MPDZELLEN >= 350000 && analyseX.TIERARTID == 1) { _cellVariants.MPDZELLEN = 'danger' }
                if (typeof analyseX.MPDKEIME == 'number' && analyseX.MPDKEIME >= 80000 && analyseX.TIERARTID == 1) { _cellVariants.MPDKEIME = 'danger' }
                // if (typeof analyseX.MPDGEFRIERPUNKT == 'number' && analyseX.MPDGEFRIERPUNKT >= -0.516 && analyseX.TIERARTID == 1) { _cellVariants.MPDGEFRIERPUNKT = 'danger' }
                // if (typeof analyseX.MPDMSGCODELABOR == 'number' && analyseX.MPDMSGCODELABOR >= 1) { _cellVariants.MPDMSGCODELABOR = 'danger' }
                analyseX._cellVariants = _cellVariants
                return analyseX
            })
            state.analysen.push(...analysen)
            bus.$emit('analysenLoaded')
        },
        buildFilteredAnalyen: async function (state, filter) {
            //console.log(filter)
            //state.filter = value
            let filtered = []
            state.analysen.forEach(function (element) {
                if (filter.von != null && typeof filter.von.getMonth != 'undefined' && new Date(element.MPDDATUM) < filter.von) {
                    //console.log('filter von active')
                    return true
                }
                if (filter.bis != null && typeof filter.bis.getMonth === 'function' && new Date(element.MPDDATUM) > filter.bis) {
                    //console.log('filter bis active')
                    return true
                }
                if (typeof filter.AnatypID === 'number' && filter.AnatypID != 0 && filter.AnatypID != element.ANATYPID) {
                    //console.log('filter anatyp active')
                    return true
                }
                if (typeof filter.tierartID === 'number' && filter.tierartID != 0 && filter.tierartID != element.TIERARTID) {
                    //console.log('filter tierart active')
                    return true
                }
                if (typeof filter.btrid === 'number' && filter.btrid != 0 && filter.btrid != element.MPDBASBTRID) {
                    //console.log('filter basbtrid active')
                    return true
                }
                filtered.push(element)
            })
            state.analysenFiltered = filtered
        },
        setProbetypSelected: function (state, value) {
            state.probetypSelected = value
        },
        setAnatypSelected(state, value) {
            state.anatypSelected = value
        },
        setAnalysenSortTableBy(state, value) {
            if (typeof value == "undefined" || value === null) return
            state.sortTable.sortBy = value
        },
        setAnalysenSortTableDesc(state, value) {
            state.sortTable.sortDesc = value
        }
    }
}